const initialState = {
  permissionsList: [],
  addPermissions: [],
  isFetchingPermissionsList: false,
  isAddingPermissions: false
};

const PermissionReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_GET_Permissions":
      return { ...state, isFetchingPermissionsList: true };
    case "SUCCESS_GET_Permissions":
      return { ...state, permissionsList: action.payload, isFetchingPermissionsList: false }
    case "ERROR_GET_Permissions":
      return { ...state, isFetchingPermissionsList: false };


    case "REQUEST_ADD_PERMISSION":
      return { ...state, isAddingPermissions: true };
    case "SUCCESS_ADD_PERMISSION":
      return { ...state, addPermissions: action.payload, isAddingPermissions: false }
    case "ERROR_ADD_PERMISSION":
      return { ...state, isAddingPermissions: false };


    default:
      return state;
  }
}
export default PermissionReducer;

